import React from "react";
import { IndividualResultForm } from "../../components/IndividualResultForm";
import Layout from "../../components/shared/Layout/Layout";

const IndividualResultInd = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Individual Result">
        <IndividualResultForm searchParams="individual" />
      </Layout>
    </div>
  );
};

export default IndividualResultInd;
